import { Game } from '@repo/types'
import { ToggleSwitch } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import React from 'react'

import { useGameContext } from '@/pages/game/context/game-context'
import { updateGameSetting } from '@/store/game/updateGameDocument'

import { SettingsRow } from '../../SettingsRow'

const SETTING_NAME = 'Previous Questions'
const SETTING_ID = 'jumbotron.enablePreviousQuestions' as const

export const EnableJumbotronPreviousQuestions = observer(
  function EnableJumbotronPreviousQuestions(): React.ReactElement | null {
    const { gameData, gameId, tracker } = useGameContext()

    if (gameData.type !== 'trivia') return null

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { checked } = event.target

      const update: Pick<Game, typeof SETTING_ID> = {
        [SETTING_ID]: checked
      }

      void updateGameSetting(gameId, update)
      tracker.changeToggle(`Jumbotron ${SETTING_NAME}`, checked)
    }
    return (
      <SettingsRow description='Show the last three questions on screen.' heading={SETTING_NAME}>
        <ToggleSwitch
          id={SETTING_ID}
          isChecked={gameData.jumbotron.enablePreviousQuestions}
          onChange={handleChange}
        />
      </SettingsRow>
    )
  }
)
